var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSisley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85.391,
    height: 61.184,
    viewBox: "0 0 85.391 61.184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 85.391,
    height: 61.184,
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_99",
    "data-name": "Groupe 99",
    opacity: 0.375
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_97",
    "data-name": "Groupe 97",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_31",
    "data-name": "Trac\\xE9 31",
    d: "M278.268,10.362a12.053,12.053,0,0,0-1.06-3.709c-2.2-4.7-5.729-6.922-10.532-6.624a.538.538,0,0,0-.281.2,71.629,71.629,0,0,1,2.418,7.75c.182.811.348,1.606.48,2.385a31.144,31.144,0,0,1,.414,6.359,34.086,34.086,0,0,1-.431,3.941,44.048,44.048,0,0,1-1.027,4.4q-.621,2.186-1.838,5.465c-.232.6-.464,1.225-.712,1.888a29.458,29.458,0,0,0,2.8-1.888,30.621,30.621,0,0,0,4.355-3.974,22.948,22.948,0,0,0,3.842-5.9,18.42,18.42,0,0,0,1.01-2.765,19.191,19.191,0,0,0,.712-5.928,12.307,12.307,0,0,0-.149-1.606",
    transform: "translate(-221.702 -0.003)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32",
    "data-name": "Trac\\xE9 32",
    d: "M283.658,44.874a3.5,3.5,0,0,1,.133.381,13.248,13.248,0,0,1,.53,5,9.933,9.933,0,0,1-.994,3.262c-.248.48-.563,1.027-.944,1.656-.248.4-.513.795-.811,1.225A47.187,47.187,0,0,1,275.1,63.42c-.613.546-1.159,1.093-1.673,1.623a27.445,27.445,0,0,0-4.421,5.4,1.108,1.108,0,0,0-.05.116c-.017.033-.017.066.05.083,0-.083.017-.1.1-.083a33.347,33.347,0,0,1,7.452-2.086,37.634,37.634,0,0,0,7.369-2.02,19.584,19.584,0,0,0,2.534-1.408,14.277,14.277,0,0,0,3.03-2.649,11.713,11.713,0,0,0,2.832-6.574c0-.215.033-.431.033-.646a13.008,13.008,0,0,0-1.192-5.945,15.6,15.6,0,0,0-2.931-4.355c-.232-.232-.464-.447-.712-.662a11.453,11.453,0,0,0-5.349-2.848,30.286,30.286,0,0,1,1.49,3.511",
    transform: "translate(-224.41 -34.514)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33",
    "data-name": "Trac\\xE9 33",
    d: "M306.541,223.271q-.546-.447-1.043-.894a29.382,29.382,0,0,0-5-3.362,19.916,19.916,0,0,0-8-2.186,12.8,12.8,0,0,0-7.9,1.855,18.306,18.306,0,0,1,5.614,3.693c.348.315.679.646,1.01.994.613.629,1.523,1.59,2.732,2.9a28.458,28.458,0,0,0,2.947,2.765,22.162,22.162,0,0,0,6.359,3.643,24.052,24.052,0,0,0,8.362,1.441,20.679,20.679,0,0,0,8.081-1.391,8.126,8.126,0,0,0,1.358-.811c.331-.232.762-.53,1.292-.927a3.383,3.383,0,0,0,.364-.265c.133-.133.182-.232.116-.331a16.1,16.1,0,0,1-9.538-1.921,45.141,45.141,0,0,1-6.756-5.2",
    transform: "translate(-237.473 -180.903)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_34",
    "data-name": "Trac\\xE9 34",
    d: "M204.205,240.817c0-.166-.033-.331-.033-.53a11.6,11.6,0,0,0-1.706-4.918,30.091,30.091,0,0,0-3.2-4.14c-.58-.679-1.06-1.209-1.391-1.59-.083-.083-.166-.149-.232-.215a15.959,15.959,0,0,0-1.888-1.706c-2.136-1.706-3.858-2.434-5.166-2.153a9.944,9.944,0,0,0-4.189,2.153,19.4,19.4,0,0,0-2.086,1.921c-.447.48-.927,1.01-1.424,1.59a20.4,20.4,0,0,0-4.5,7.5,10.312,10.312,0,0,0-.331,2.086,8.8,8.8,0,0,0,.48,3.66,6.638,6.638,0,0,0,3.279,3.908,8.762,8.762,0,0,0,4.786.811,11,11,0,0,0,4.769-1.391,8.117,8.117,0,0,0,6.806,1.308,6.992,6.992,0,0,0,5.117-3.461,9.59,9.59,0,0,0,.911-4.835",
    transform: "translate(-148.55 -188.165)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_35",
    "data-name": "Trac\\xE9 35",
    d: "M184.092,10.36q.224-1.267.546-2.583A79.893,79.893,0,0,1,187.023.143a9.065,9.065,0,0,0-7.915,2.434,12.075,12.075,0,0,0-2.567,3.3,12.367,12.367,0,0,0-1.424,4.289.874.874,0,0,0-.017.2,17.994,17.994,0,0,0,1.474,10.3,21.346,21.346,0,0,0,1.954,3.395,29.111,29.111,0,0,0,6.309,6.475c.878.646,1.788,1.292,2.749,1.888-.215-.679-.447-1.308-.629-1.888-.977-2.832-1.573-4.653-1.8-5.465-.414-1.523-.762-3-1.01-4.4a32.879,32.879,0,0,1-.464-4.04,32.505,32.505,0,0,1,.414-6.259",
    transform: "translate(-145.94 0)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36",
    "data-name": "Trac\\xE9 36",
    d: "M245.729,75.329c-.96-.414-1.755-.05-2.451,1.076a7.026,7.026,0,0,0-.96,3.13,21.22,21.22,0,0,0-.017,3.842,25.288,25.288,0,0,0,.5,3.593,14.517,14.517,0,0,0,2.136,5.63,37.212,37.212,0,0,0,1.788-4.156,18.973,18.973,0,0,0,1.043-5.017v-.05a19.138,19.138,0,0,0-.248-4.852c-.348-1.755-.96-2.815-1.788-3.2",
    transform: "translate(-202.113 -62.717)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_37",
    "data-name": "Trac\\xE9 37",
    d: "M115.66,44.874a14.218,14.218,0,0,1,.795-2.136c.083-.132.232-.348.431-.646a1.061,1.061,0,0,0,.166-.729h-.1a12.87,12.87,0,0,0-5.812,3.511,11.475,11.475,0,0,0-1.391,1.672,14.645,14.645,0,0,0-2.12,4.14,13.179,13.179,0,0,0-.662,4.488c0,.215.017.431.033.646a11.3,11.3,0,0,0,2.964,6.624,14.5,14.5,0,0,0,2.981,2.6,16.324,16.324,0,0,0,2.55,1.408,38.533,38.533,0,0,0,7.485,2.037,33.579,33.579,0,0,1,7.435,2.153,22.108,22.108,0,0,0-3.477-4.6c-.2-.2-.53-.53-1.01-.994-.762-.712-1.871-1.772-3.328-3.146a42.709,42.709,0,0,1-4.156-4.355,22.353,22.353,0,0,1-1.623-2.368,14.972,14.972,0,0,1-1.325-2.881,10.855,10.855,0,0,1-.331-5.1,16.9,16.9,0,0,1,.5-2.318",
    transform: "translate(-89.249 -34.514)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_38",
    "data-name": "Trac\\xE9 38",
    d: "M17.486,222.3c-.381.331-.795.662-1.192.994a44.509,44.509,0,0,1-6.74,5.133A15.7,15.7,0,0,1,0,230.313c.315.215.845.662,1.623,1.325a8.193,8.193,0,0,0,1.788,1.126,23.1,23.1,0,0,0,10.763,1.11,22.13,22.13,0,0,0,9.141-3.063,26.1,26.1,0,0,0,3.958-3.08c.431-.414,1.59-1.557,3.461-3.444q1.068-1.068,2.086-1.987a20.725,20.725,0,0,1,5.514-3.693,13.292,13.292,0,0,0-8.081-1.855,20.067,20.067,0,0,0-7.932,2.285,29.211,29.211,0,0,0-4.835,3.262",
    transform: "translate(0 -180.824)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSisley);
export default __webpack_public_path__ + "static/media/LogoSisley.43490e3e882c1a6e937d47da31a93f06.svg";
export { ForwardRef as ReactComponent };